// const addGiftProductToCart = async (variantId, quantity) => { 
//   const url = '/cart/add.js';
//   const data = { id: variantId, quantity, sections: ['mini-cart'] };

//   try {
//     const response = await fetch(url, {
//       method: 'POST', 
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(data)
//     });

//     if (!response.ok) throw new Error('Network response was not ok ' + response.statusText);

//     const responseJson = await response.json();
//     console.log('Item added to cart:', responseJson);

//     // const cartResponse = await fetch(theme.routes.cart);
//     // const cartContent = await cartResponse.json();

//     // document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
//     //   bubbles: true,
//     //   detail: { cart: cartContent }
//     // }));

//     // const miniCartStatus = document.querySelector('#CartDrawer')?.getAttribute('drawer--is-open') === '';
    
//     // document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
//     //   bubbles: true,
//     //   detail: { cart: cartContent, openMiniCart: miniCartStatus }
//     // }));

//     return true;
//   } catch (error) {
//     console.error('There was a problem with the fetch operation:', error);
//     return false;
//   }
// };

// const removeGiftProduct = async (variantId) => {
//   const url = '/cart/change.js';
//   const data = { id: variantId, quantity: 0 };

//   try {
//     const response = await fetch(url, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(data)
//     });

//     if (!response.ok) throw new Error('Network response was not ok ' + response.statusText);

//     const cart = await response.json();
//     console.log('Item removed from cart:', cart);
//     return true;
//   } catch (error) {
//     console.error('Error removing item from cart:', error);
//     return false;
//   }
// };

// function animateCounter(element, duration) {
//   const end = parseInt(element.dataset.value, 10);
//   const startTime = performance.now();

//   const updateCounter = (currentTime) => {
//     const progress = Math.min((currentTime - startTime) / duration, 1);
//     element.value = Math.floor(progress * end);
//     if (progress < 1) requestAnimationFrame(updateCounter);
//   };
//   requestAnimationFrame(updateCounter);
// }

// const checkFreeGifts = async () => {
//   const updateContainer = async (selector) => {
//     const container = document.querySelector(selector);
//     if (container) {
//       try {
//         const response = await fetch(window.location.href);
//         const html = await response.text();
//         const parser = new DOMParser();
//         const doc = parser.parseFromString(html, "text/html");
//         const newContent = doc.querySelector(selector);
//         if (newContent) container.innerHTML = newContent.innerHTML;
//       } catch (error) {
//         console.error(`Error updating ${selector}:`, error);
//       }
//     }
//   };

//   await Promise.all([
//     updateContainer(".drawer__contents--progress"),
//     updateContainer(".drawer__footer"),
//     updateContainer(".drawer__inner .cart__items")
//   ]);

//   const counterInput = document.getElementById("counterInput");
//   if (counterInput) animateCounter(counterInput, 800);

//   const freeGiftCircles = document.querySelectorAll('.rewardbar .rewardbar-freegift-circle');
//   const cartProductItems = document.querySelectorAll('.drawer__contents .cart__item .cart__item-name');
//   const activeCircle = Array.from(freeGiftCircles).find(circle => circle.classList.contains('active'));
//   const dataProductValues = Array.from(freeGiftCircles)
//     .map(circle => circle.getAttribute('data-product'))
//     .filter(Boolean);

//   if (activeCircle) {
//     const productData = activeCircle.getAttribute('data-product');
//     const matchingCartItem = Array.from(cartProductItems).find(item =>
//       item.getAttribute('data-variant') === productData
//     );

//     if (!matchingCartItem) {
//       console.log('Adding free gift:', productData);
//       const added = await addGiftProductToCart(productData, 1);
//       if (added && theme?.CartDrawer) {
//         new theme.CartDrawer().init();
//         typeof initRecommendedSlider === "function" && initRecommendedSlider();
//       }
//     } else {
//       console.log('Free gift already in cart:', productData);
//     }
//   } else {
//     const matchingCartItems = Array.from(cartProductItems).filter(item =>
//       dataProductValues.includes(item.getAttribute('data-variant'))
//     );

//     if (matchingCartItems.length > 0) {
//       for (const item of matchingCartItems) {
//         const variantId = item.getAttribute('data-variant');
//         await removeGiftProduct(variantId);
//       }

//       if (theme?.CartDrawer) {
//         new theme.CartDrawer().init();
//       }
//     } else {
//       console.log('No free gift to remove.');
//     }
//     typeof initRecommendedSlider === "function" && initRecommendedSlider();
//   }
// };
 



const FREE_GIFT_TRIGGER_COUNT = 3;
const FREE_GIFT_VARIANT_ID = document
  .querySelector(".rewardbar-freegift-circle")
  .getAttribute("data-product");

let isInternalUpdate = false;
let lastShouldHaveGift = null;

const checkFreeGifts = async () => {
  const updateContainer = async (selector) => {
    const container = document.querySelector(selector);
    if (container) {
      try {
        const response = await fetch(window.location.href);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const newContent = doc.querySelector(selector);
        if (newContent) container.innerHTML = newContent.innerHTML;
      } catch (error) {
        console.error(`Error updating ${selector}:`, error);
      }
    }
  };

  await Promise.all([
    updateContainer(".drawer__contents--progress"),
    updateContainer(".drawer__footer"),
    updateContainer(".drawer__inner .cart__items"),
  ]);

  if (isInternalUpdate) return;

  try {
    const res = await fetch("/cart.js");
    const cart = await res.json();

    // Remove gift from real items list
    const realCartItems = cart.items.filter(
      (item) => item.variant_id.toString() !== FREE_GIFT_VARIANT_ID
    );

    // Find gift item in cart
    const giftItem = cart.items.find(
      (item) => item.variant_id.toString() === FREE_GIFT_VARIANT_ID
    );

    // ✅ Check if ANY single product has quantity >= 3
    const qualifyingItem = realCartItems.find(
      (item) => item.quantity >= FREE_GIFT_TRIGGER_COUNT
    );

    const shouldHaveGift = Boolean(qualifyingItem);
    const hasGift = Boolean(giftItem);

    // Initialize state on first run
    if (lastShouldHaveGift === null) {
      lastShouldHaveGift = shouldHaveGift;
      return;
    }

    // No threshold change → do nothing
    if (shouldHaveGift === lastShouldHaveGift) return;

    isInternalUpdate = true;

    // Add gift
    if (shouldHaveGift && !hasGift) {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: FREE_GIFT_VARIANT_ID,
          quantity: 1,
        }),
      });
    }

    // Remove gift
    if (!shouldHaveGift && hasGift) {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: giftItem.key,
          quantity: 0,
        }),
      });
    }

    lastShouldHaveGift = shouldHaveGift;

    // Refresh cart drawer
    if (theme?.CartDrawer) {
      new theme.CartDrawer().init();
      typeof initRecommendedSlider === "function" &&
        initRecommendedSlider();
    }
  } catch (error) {
    console.error("Free gift error:", error);
  } finally {
    setTimeout(() => {
      isInternalUpdate = false;
    }, 400);
  }

  typeof initRecommendedSlider === "function" &&
    initRecommendedSlider();
};

